//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast, PullRefresh,Empty,Overlay} from 'vant';
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
export default {
 name: 'home',
 data(){
    return {
      selType: 1,//查询数据类型 1查询案例  2查询企业
      oneProdTypeList: null,//产品行业分类
      twoProdTypeList: null,//产品行业分类
      threeProdTypeList: null,//产品行业分类
      
      companyTypeList: null,//企业的行业类型
      searchStr: this.$route.query.searchStr,//输入框  搜索条件
      searchStrCompany: this.$route.query.searchStrCompany,
      pageSizeSel: 9,//分页条数

      checkOneProdType: "-1",//选中的产品案例行业分类id
      checkTwoProdType: "-1",//选中的产品案例2级分类id
      checkThreeProdType: "-1",//选中的产品案例3级分类id

      xmpcCpalSelObj: null,
      loadProdCaseName: "加载更多",//产品方案底部加载更多按钮名称
      canSelProdCase: true,//是否还能点击加载更多产品方案  true可以，false已经全显示完了
      releaseProdCaseList: [],//当前显示的产品方案list

      checkCompanyType: "-1",//选中的企业行业类型id
      companySelObj: null,
      loadCompanyName: "加载更多",//企业信息底部加载更多按钮名称
      canSelCompany: true,//是否还能点击加载更多企业信息  true可以，false已经全显示完了
      companyInfoList: [],//当前显示的企业信息list
      societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
    }
  },
 components:{
    Header,
    Footer
 },

  methods:{
    hideTel(e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
       document.querySelectorAll("div.box").forEach((item)=>{
        item.style.display = "none"
      })

    },
    showTel(e){
      this.fnStopBub(e);
      document.querySelectorAll("div.box").forEach((item)=>{
        item.style.display = "none"
      })
      e.currentTarget.nextElementSibling.style.display = "block"
    },
    fnRmgjcSel(searchStr,e){
      this.fnStopBub(e);
      this.searchStr = searchStr;
      this.fnInitData();
    },
     //切换查询数据类型 ：企业 、 产品
    fnChangeSelType(selType,e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
      let that = this;
      that.selType = selType;
    },
     //第一次进页面，初始化页面数据
    fnInitDataOne(e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
      let that = this;
      that.canSelProdCase = true;
      that.canSelCompany = true;
      //初始化案例分类
      that.fnLoadProdTypeList();
      //初始化产品案例list
      that.fnLoadReleaseProdCase(2);
      //初始化企业行业分类
      that.fnInitCompanyType();
      //初始化企业list
      that.fnLoadCompanyInfo(2);
    },
    //各种条件出发查询  页面数据方法
    fnInitData(e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
      let that = this;
      that.canSelProdCase = true;
      that.canSelCompany = true;
      if(that.selType == 1){//查询数据类型 1查询案例  2查询企业
        //初始化案例分类
        that.fnInitProdType();
        
        //初始化产品案例list
        that.fnLoadReleaseProdCase(2);
      }else{
        //初始化企业行业分类
        that.fnInitCompanyType();
        //初始化产品案例list
        that.fnLoadCompanyInfo(2);
      }
    },
    //切换产品分类选项页
    showProdTypeTab(params,e){
      this.fnStopBub(e);
      this.checkProdType = params;
      this.fnLoadReleaseProdCase(2);
    },
    //初始化案例分类
    // fnInitProdType(){
    //   let that = this;
    //   let obj = new Object();
    //   requestByPost(API.selAllProdCaseType,JSON.stringify(obj)).then((res)=>{
    //     if(res.data.objs != null && res.data.objs.length != 0){
    //       that.oneProdTypeList = res.data.objs;
    //       // that.twoProdTypeList = res.data.data;
    //       // that.threeProdTypeList = res.data.otherList;
    //     }

    //   })
    // },
    fnClickButton(e){
      this.fnStopBub(e);
      if(this.selType == 1){//查询数据类型 1查询案例  2查询企业
        //初始化产品案例list
        this.fnLoadReleaseProdCase(2);
      }else{
        //初始化产品案例list
        this.fnLoadCompanyInfo(2);
      }
    },
    /* 加载更多方案数据*/
    fnLoadReleaseProdCase(inType){
      let that = this;
      if(inType == 2){
        that.canSelProdCase = true;
      }
      if(that.canSelProdCase){//说明还有更多的产品信息
         if(inType == 1){//分页查询
          let page = that.xmpcCpalSelObj.page;
          page.pageNum = Number(page.pageNum)+1;
          that.xmpcCpalSelObj.page = page;
        }else{
          that.releaseProdCaseList = [];
          let page = that.xmpcCpalSelObj.page;
          page.pageNum = 0;
          page.pageSize = that.pageSizeSel;
          that.xmpcCpalSelObj.page = page;
          that.xmpcCpalSelObj.selSysProdTypeId = that.checkOneProdType;
          that.xmpcCpalSelObj.selParentProdTypeId = that.checkTwoProdType;
          that.xmpcCpalSelObj.selProdTypeId = that.checkThreeProdType;
        }
        that.xmpcCpalSelObj.searchStr = that.searchStr;
        let postUrl = null;
        if(that.societyId != undefined && that.societyId != null && that.societyId != ""){
          //查询机构内的所有企业的案例
          that.xmpcCpalSelObj.societyId = that.societyId;
          postUrl = API.selSocietyProdCasePage;
        }else{
          //查询平台所有企业案例
          postUrl = API.selReleaseProdCasePageFormEs;
          that.xmpcCpalSelObj.societyId = null;
        }
        requestByPost(postUrl,JSON.stringify(that.xmpcCpalSelObj)).then((res)=>{
          let reObj = res.data.obj;
          let reList = null;
          if(reObj != null && reObj != undefined){
            if(that.societyId != null && that.societyId != undefined && that.societyId != ''){
              //查询机构内的所有企业的案例
              reList = res.data.obj.societyReleaseProdCaseList;
            }else{
              //查询平台所有企业案例
              reList = res.data.obj.releaseProdCaseList;
            }
          }
          if(reObj != null && reList != null &&  reList.length != 0){
            that.loadProdCaseName = "加载更多";
            that.canSelProdCase = true;
            if(inType == 1){//分页查询
              reList.forEach((item, index) => {
                that.releaseProdCaseList.push(item);
                if(that.releaseProdCaseList.length == res.data.obj.page.total){
                  that.loadProdCaseName = "~没有更多了~";
                  that.canSelProdCase = false;
                }
              })
            }else{
               that.releaseProdCaseList = reList;
               if(that.releaseProdCaseList.length == res.data.obj.page.total){
                  that.loadProdCaseName = "~没有更多了~";
                  that.canSelProdCase = false;
                }
            }

          }else{
            if(inType == 2){//
               that.releaseProdCaseList = [];
            }
            that.canSelProdCase = false;
            that.loadProdCaseName = "~没有更多了~";
          }
        })
      }else{
        //说明该条件下的产品已经全显示出来啦
         Toast('没有更多了')
      }
    },



    //切换企业分类选项页
    showCompanyTypeTab(params,tem,e){
      this.fnStopBub(e);
      this.checkCompanyType = params;
      tem.flag = !tem.flag
      this.fnLoadCompanyInfo(2);
    },
    //初始化企业行业分类
    fnInitCompanyType(){
      let that = this;
      var selObj = new Object();
      requestByPost(API.selCompanyTypeFormDb,JSON.stringify(selObj)).then((res)=>{
        if(res.data != undefined && res.data.objs != undefined && res.data.objs != null && res.data.objs.length != 0){
          that.companyTypeList = res.data.objs;
        }else{
          that.companyTypeList = null;
        }
      })
    },

    //初始化产品分类list
    fnLoadProdTypeList(){
      let that = this;
      var selObj = new Object();
      requestByPost(API.selProdTypeFormDb,JSON.stringify(selObj)).then((res)=>{
        if(res.data != undefined && res.data.objs != undefined && res.data.objs != null && res.data.objs.length != 0){
          that.oneProdTypeList = res.data.objs;
        }else{
          that.oneProdTypeList = null;
        }
      })
    },


    /* 加载更多企业数据*/
    fnLoadCompanyInfo(inType){
      let that = this;
      if(inType == 2){
        that.canSelCompany = true;
      }
      if(that.canSelCompany){//说明还有更多的产品信息
         if(inType == 1){//分页查询
          let page = that.companySelObj.page;
          page.pageNum = Number(page.pageNum)+1;
          that.companySelObj.page = page;
        }else{
          that.companyInfoList = [];
          let page = that.companySelObj.page;
          page.pageNum = 0;
          page.pageSize = that.pageSizeSel;
          that.companySelObj.page = page;
          that.companySelObj.companyType = that.checkCompanyType;
        }
        that.companySelObj.searchStr = that.searchStrCompany;
        let postUrl = null;
        if(that.societyId != null && that.societyId != undefined && that.societyId != ''){
          //查询机构内的所有企业的案例
          that.companySelObj.societyId = that.societyId;
          postUrl = API.selSocietyCompanyPageFormEs;
        }else{
          //查询平台所有企业案例
          postUrl = API.selCompanyInfoPageFormEs;
          that.companySelObj.societyId = null;
        }
        requestByPost(postUrl,JSON.stringify(that.companySelObj)).then((res)=>{
          let reObj = res.data.obj;
          let reList = null;
          if(reObj){
            if(that.societyId != null && that.societyId != undefined && that.societyId != ''){
              //查询机构内的所有企业的案例
              reList = res.data.obj.societyCompanyList;
            }else{
              //查询平台所有企业案例
              reList = res.data.obj.companyInfoList;
            }
          }
          
          if(reObj != null && reList != null &&  reList.length != 0){
            that.loadCompanyName = "加载更多";
            that.canSelCompany = true;
            if(inType == 1){//分页查询
              reList.forEach((item, index) => {
                that.companyInfoList.push(item);
                if(that.companyInfoList.length == res.data.obj.page.total){
                  that.loadCompanyName = "~没有更多了~";
                  that.canSelCompany = false;
                }
              })
            }else{
               that.companyInfoList = reList;
               if(that.companyInfoList.length == res.data.obj.page.total){
                  that.loadCompanyName = "~没有更多了~";
                  that.canSelCompany = false;
                }
            }

          }else{
            if(inType == 2){//
              that.companyInfoList = [];
            }
            that.canSelCompany = false;
            that.loadCompanyName = "~没有更多了~";
          }
        })
      }else{
        //说明该条件下的企业已经全显示出来啦
         Toast('没有更多了')
      }
    },
    //跳转到案例详情页
    fnGotoCaseDetail(releaseProdCase,e){
      this.fnStopBub(e);
      this.$store.commit('home/setSelInputType', 0);
      if(this.societyId != null && this.societyId != undefined && this.societyId != ''){
         this.$router.push({path: '/caseDetail', query: {projectId:releaseProdCase.releaseProdCaseId,inType:1}});
      }else{
        this.$router.push({path: '/caseDetail', query: {projectId:releaseProdCase.id,inType:1}});
      }
     
    },
    //跳转到企业发布信息详情页
    fnGotoCompanyDetail(companyInfo,e){
      this.fnStopBub(e);
      this.$store.commit('home/setSelInputType', 0);
      if(this.societyId != null && this.societyId != undefined && this.societyId != ''){
        this.$router.push({path: '/companyDetailNew-old', query: {companyId:companyInfo.companyId,inType:1}});
      }else{
        this.$router.push({path: '/companyDetailNew-old', query: {companyId:companyInfo.id,inType:1}});
      }
       
    },
    fnChangeProdTypeNew(prodTypeId,e){
      this.fnStopBub(e);
      let that = this;
      that.checkOneProdType = prodTypeId;//所选择的标准件产品 分类id  第1级
      that.fnLoadReleaseProdCase(2);
    },
    /**通过行业分类，加载产品二级分类、三级分类 */
    fnChangeTwoAndThreeProdType(prodTypeId,level,e){
      this.fnStopBub(e);
      let that = this;
      if(level == 0){
        that.checkOneProdType = prodTypeId;//所选择的标准件产品 分类id  第1级
        that.checkTwoProdType = "-1";//所选择的标准件产品 分类id  第2级
        that.checkThreeProdType =  "-1";//所选择的标准件产品 分类id  第3级
      }else if(level == 1){
        that.checkTwoProdType = prodTypeId;//所选择的标准件产品 分类id  第2级
        that.checkThreeProdType =  "-1";//所选择的标准件产品 分类id  第3级
      }else if(level == 2){
        that.checkThreeProdType =  prodTypeId;//所选择的标准件产品 分类id  第3级
      }
      let obj = new Object();
      if(level == 0){
          obj.sysPid = prodTypeId;
      }else if(level == 1){
        obj.sysPid = that.checkOneProdType;
        obj.pid = prodTypeId;
      }
      obj.level = level;
      obj.companyId = that.companyId;
      obj.inType = 1;
      requestByPost(API.selTwoAndThreeProdType,JSON.stringify(obj)).then((res)=>{
        if(level == 0){//说明点击的是行业分类
          that.twoProdTypeList = res.data.objs;
          console.log("二级分类："+JSON.stringify(res.data.objs));
        }
        that.threeProdTypeList = res.data.otherList;
        console.log("二级分类："+JSON.stringify(res.data.otherList));
        //根据条件加载产品信息
        // that.fnLoadProdInfo(2,prodTypeId,level,e);
        that.fnLoadReleaseProdCase(2);
      })
    },
     fnClickThreeProdType(prodTypeId,e){
       this.fnStopBub(e);
       this.checkThreeProdType =  prodTypeId;//所选择的标准件产品 分类id  第3级
       this.fnLoadReleaseProdCase(2);
     },
     //跳转到平台首页
    fnGoToHomePage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/home'});
    },
    fnGetFontSizeNum(companyName){
       // 分辨率控制字体大小
      if(window.screen.width <= 1367 && companyName.length > 17){
        return  "font-size: 18px;";
      }
      return "font-size: 21px;";
    },
    //分辨率控制公司关键字显示数量
    fnGetShowLeyWordArr(keywordValueArr){
      let showArr = [];
      if(window.screen.width <= 1367){
        if(keywordValueArr != null && keywordValueArr.length > 0){
          if(keywordValueArr.length > 2){
            let num = 0;
            $(keywordValueArr).each(function(index,keyword){
              num += keyword.length;
              if(index == 0){
                showArr[showArr.length] = keyword;
              }else if(index == 1){
                showArr[showArr.length] = keyword;
              }else if(index == 2){
                if(num < 20){
                    showArr[showArr.length] = keyword;
                }
              }
            });
          }else if(keywordValueArr.length <= 2){
            showArr = keywordValueArr;
          }
        }
        return  showArr;
      }else if(window.screen.width <= 1600){
        if(keywordValueArr != null && keywordValueArr.length > 0){
          if(keywordValueArr.length > 2){
            let num = 0;
            $(keywordValueArr).each(function(index,keyword){
              num += keyword.length;
              if(index == 0){
                showArr[showArr.length] = keyword;
              }else if(index == 1){
                showArr[showArr.length] = keyword;
              }else if(index == 2){
                if(num < 22){
                    showArr[showArr.length] = keyword;
                }
              }
            });
          }else if(keywordValueArr.length <= 2){
            showArr = keywordValueArr;
          }
          return  showArr;
        }
      }else{
        return keywordValueArr;
      }
    }
    
  },
  mounted(){
    document.title = "找合作"
  },
  created(){
    let that = this;
    that.xmpcCpalSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"searchStr": that.searchStr};
    that.companySelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"searchStr": that.searchStr};
     
    this.$store.commit('home/setMenuStyle', 3);//为了显示灰色头部背景   2025数字云平台位置
    this.$store.commit('home/setMenuActive', 1);
    that.selType = (that.$route.query.selType != null && this.$route.query.selType != "" ) ? this.$route.query.selType : 1;
    if(that.selType == 2){
      that.$store.commit('home/setMenuActive', 1);////
    }
    // that.$store.commit('home/setSelInputType', 1);////0显示跳转页面的搜索框   1显示当前页面搜索的搜索框
    // if(that.societyId != null && that.societyId != '' && that.societyId != undefined){
    //   that.$store.commit('home/setSocietyLogoUrl', window.localStorage.getItem('logoImgUrl'));
    // }
    that.fnInitDataOne();
    
    
  },
  updated(){
    //每个16:9的图片加载完重新算高度
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
    //每个16:7.52的图片(企业封面)加载完重新算高度
    $$(".autoCompanyImgHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*7.52/16);
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/search-old.vue